export enum HOME_INTERNET_TARIFFS__CONSTANTS {
  ORDER = 'Подключить',
  ADD_BUTTON = 'Добавить в тариф',
  ADDED_BUTTON = 'Добавлено',
  ABOUT_TARIFF_BUTTON = 'Подробнее о тарифе',
  ABOUT_MOBILE_TARIFF_BUTTON = 'Подробнее о мобильном тарифе',
  SBERBOX = 'sberbox',
}
